const contrastYIQ = (hexColor?: string, opacity = 1) => {
    if (!hexColor) {
        return 'black';
    }

    const hexcolor = hexColor.startsWith('#') ? hexColor.substring(1) : hexColor;
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq >= 128 ? `rgba(0, 0, 0, ${opacity})` : `rgba(255, 255, 255, ${opacity})`;
};

export default contrastYIQ;
